import { createContext } from "react";

// store
import { initial, State } from "./store";

export interface Actions {
	hideDetailDialog: () => void;
	hideDeleteDialog: () => void;
	showDetailDialog: (id: string) => void;
	showDeleteDialog: (ids: string[]) => void;
}

export interface ContextType {
	state: State;
	actions: Actions;
}

const defaultContextValues: ContextType = {
	state: initial,
	actions: {
		showDetailDialog: () => {},
		showDeleteDialog: () => {},
		hideDetailDialog: () => {},
		hideDeleteDialog: () => {}
	}
};

export default createContext<ContextType>(defaultContextValues);
